/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Membership_Stripe_Ends_OnInputs */

const fr_membership_stripe_ends_on = /** @type {(inputs: Membership_Stripe_Ends_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fin le ${i?.date}`)
};

/**

* @param {Membership_Stripe_Ends_OnInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_stripe_ends_on = /** @type {((inputs: Membership_Stripe_Ends_OnInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Stripe_Ends_OnInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_stripe_ends_on(inputs)
});